import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './AppRouter';
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<BrowserRouter data-id="element-196">
    <AppRouter data-id="element-197" />
  </BrowserRouter>);